<div class="industry-chart-section-wrapper">
  <!-- <app-ticker-fy-info [tickers]="dataToUse.tickers">
  </app-ticker-fy-info> -->
  <div class="chart-section" nz-row nzGutter="8">
    <!-- <div class="chart-details" nz-col [nzSpan]="6">
      Left Side - Line Item and Ticker Details
    </div> -->
    <div class="chart industry-chart-container" nz-col [nzSpan]="24">
      <app-chart-plotter
        [chartType]="chartType"
        [dataToUse]="dataToUse"
        pageName="industry"
        (onChartInstance)="onChartInstance($event)"
      >
      </app-chart-plotter>
    </div>
  </div>
</div>
